<template>
  <div ref="containerRef" class="fluid-container-custom ">
    <filtersFilterPanel
      v-model:open="openFilters"
      :showMapType="true"
      :showCategories="false"
    ></filtersFilterPanel>
    <div class="mt-8 grid grid-cols-5">
      <div class="col-span-4">
        <div class="flex justify-start">
          <h1 class="text-2xl">
            Which countries or regions receive the most democracy support
            funding?
          </h1>
          <HelpTooltip>
            Toggle the map type on the left-hand side to visualise the data by
            country or region.
          </HelpTooltip>
        </div>
        <p class="mt-2">
          This graph showcases how democracy support funding from Europen donors
          is distributed across the world. Hover over each country to see how
          much core democracy support goes towards key democracy support
          categories in target countries. Democracy support is not always
          country specific, sometimes the focus is regional. Toggle the map on
          the left-hand side to visualise regional democracy support funding.
        </p>
      </div>
      <div class="text-right">
        <!-- <button
          class="px-4 py-1 rounded-md bg-white font-medium inline-flex text-Primary-800 gap-x-1.5 ring-1 ring-Primary-800"
          @click="openFilters = true"
        >
          Filter
          <AdjustmentsVerticalIcon
            class="-mr-1 h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
        </button> -->
      </div>
    </div>

    <div class="grid grid-cols-3 gap-2 mt-6 items-start">
      <div>
        <div class="flex gap-3 items-center">
          <span class="mini-title !mb-0"> Map type: </span>
          <button
            class="my-2 px-2 transition-all hover:text-Shades-SoftBlack"
            @click="mode = modes.countries"
            :class="
              mode === modes.countries
                ? 'border-b-2 border-Primary-600'
                : 'text-gray-400'
            "
          >
            countries
          </button>
          <button
            class="my-2 px-2 transition-all hover:text-Shades-SoftBlack"
            @click="mode = modes.regions"
            :class="
              mode === modes.regions
                ? 'border-b-2 border-Primary-600'
                : 'text-gray-400'
            "
          >
            regions
          </button>
        </div>
      </div>

      <div>
        <div
          v-if="mode === modes.countries"
          class="flex flex-row gap-3 items-center justify-end"
        >
          <span class="mini-title !mb-0"> Search </span>

          <div class="max-w-sm">
            <InterfaceComboBox
              :allAvailableOptions="store.allDonorNames"
              @update:model-value="($event) => (selectedDonor = $event)"
              caption="Donor name"
              :resetFlag="resetFlag"
            ></InterfaceComboBox>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end">
        <div>
          <button
            class="px-4 py-1 rounded-md font-medium inline-flex gap-x-1.5"
            :class="[
              ifStore.isYearFilterActive === true
                ? 'bg-Secondary-400 text-white'
                : 'bg-white text-Primary-800 ring-1 ring-Primary-800',
            ]"
            @click="openFilters = true"
          >
            Filter
            <AdjustmentsVerticalIcon
              class="-mr-1 h-5 w-5 text-Primary-800"
              :class="[
                ifStore.isYearFilterActive === true
                  ? 'text-white'
                  : ' text-Primary-800 ',
              ]"
              aria-hidden="true"
            />
          </button>
          <FiltersInlineFilters :showCategoryToggles="false">
          </FiltersInlineFilters>
        </div>
      </div>
    </div>
    <div class="mb-4 text-right"></div>
    <div id="legend" class="mt-6"></div>

    <div class="lg:flex w-full justify-between">
      <div class="flex-1">
        <!--map -->
        <template v-if="mode == modes.countries">
          <MapWorldMap
            :width="mapWidth"
            :data="resultsForMap"
            :hasSelectedCountry="selectedDonor != null"
            :showBubbleChart="false"
            @_mouseover="onCountryOver"
            @_mouseout="onCountryOut"
            @_click="($event) => onCountryClick($event)"
            :colors="[
              _Scale['50'],
              _Scale['100'],
              _Scale['200'],
              _Scale['300'],
              _Scale['400'],
              _Scale['500'],
            ]"
            :bgColor="_Primary['50']"
            nonAvailableColor="#fff"
            teleportSelector="#legend"
            :selectedGeo="selectedDonor?.iso"
            :mapScale="mapScale"
          ></MapWorldMap>
          <section class="mt-8">
            <div class="mb-14">
              <div class="flex justify-start">
                <h1 class="text-2xl">
                  How do democracy support programmes with a regional focus
                  change over time?
                </h1>
              </div>
              <p class="mt-2">
                Democracy support programmes can sometimes have a regional
                focus. This graph showcases how funding for democracy support
                programmes can shift depending on the regional focus. On the
                left-hand side, you can select different regions and observe how
                funding towards these democracy support programmes changes
                through the years.
              </p>
            </div>
            <EvoByRecipient                        
              
              :availableRecipientsObjects="
                resultsForMapBase.sort((a, b) => b.Total - a.Total)
              "
              label-field="label"
              value-field="TOTAL"
              id-field="recipient_code"
            >
              <template #title> Evolution by recipient countries </template>
            </EvoByRecipient>
          </section>
        </template>

        <template v-else-if="mode == modes.regions">
          <MapRegionsMap
            :width="mapWidth"
            :regions="resultsForBubbleChart"
            :colorRange="[_Scale['50'], _Scale['400']]"
            @_mouseover="($event) => onRegionOver($event)"
            @_mouseout="($event) => onRegionOut($event)"
            @_click="($event) => onRegionClick($event)"
            teleportSelector="#legend"
          ></MapRegionsMap>

          <section class="mt-8">
            <div class="mb-14">
              <div class="flex justify-start">
                <h1 class="text-2xl">
                  How do democracy support programmes with a regional focus
                  change over time?
                </h1>
              </div>
              <p class="mt-2">
                Democracy support programmes can sometimes have a regional
                focus. This graph showcases how funding for democracy support
                programmes can shift depending on the region. On the left-hand
                side, you can select different regions and observe how funding
                towards these democracy support programmes changes throughout
                the years.
              </p>
            </div>
            <EvoByRecipient              
              :availableRecipientsObjects="resultsForBubbleChart"
            >
            </EvoByRecipient>
          </section>
        </template>
      </div>
      <MapSidePannel
        :style="{
          visibility: selectedDonor ? 'visible' : 'hidden',
        }"
        :selected-donor="selectedDonor"
        :results="resultsForMapSelectedCountry"
        @close="closeDonor"
      />
    </div>

    <ClientOnly>
      <template v-if="tooltip.tooltipPosition.value.owner === tooltipId">
        <Teleport to="#teleport-content">
          {{ hoveredData?.label }}:
          <span class="font-bold"> {{ hoveredData?.figure }} </span>
        </Teleport>
        <Teleport to="#teleport-header">
          {{ hoveredHeader }}
        </Teleport>
      </template>
    </ClientOnly>

    <interfaceGeoModal
      v-model:showModal="showGeoModal"
      :entityName="selectedEntity.name"
      :entityId="selectedEntity.id"
      :recipients="selectedEntity.topCountries"
      :contentType="selectedEntity.contentType"
      :nodeType="selectedEntity.nodeType"
      :filterByDonorCode="selectedEntity.filterByDonorCode"
      :filterByDonorName="selectedEntity.filterByDonorName"
      :yearsFilter="ifStore.sliderYears"
    >
    </interfaceGeoModal>
    <InterfaceSourcesText class="mt-40"></InterfaceSourcesText>
  </div>
</template>

<script setup>
import { queries } from "@/assets/queries.js";
import { useBaseDataStore } from "@/stores/baseData.js";
import * as d3 from "d3";
import allRecipients from "@/assets/recipients.json";
import regionsCentroids from "@/assets/regionsCentroids.json";
const store = useBaseDataStore();
const ifStore = useInterfaceStore();
const showGeoModal = ref(false);
const selectedEntity = ref({
  name: "",
  id: "",
  type: nodeTypes.Donor,
  topCountries: [],
  topCategories: [],
});
const recipientsByRegion = d3.group(allRecipients, (d) => d.region);
import {
  ChevronDownIcon,
  CheckIcon,
  AdjustmentsVerticalIcon,
} from "@heroicons/vue/20/solid";

import { _Scale, _Primary } from "#tailwind-config/theme/colors"; // named (with _ prefix)

const modes = {
  regions: "regions",
  countries: "countries",
};

import { httpConfig } from "@/assets/baseTypes.js";
import { nodeTypes } from "@/assets/configStrings.js";
detectScreenSize();
const { $formater } = useNuxtApp();
const config = useRuntimeConfig();

const containerRef = ref(null);
const openFilters = ref(false);
const { width: availableWidth } = useElementSize(containerRef);

const resetFlag = ref(false);


/*** init block */
// await useManageAuth();

// const reloadOnError = useReloadTokenOnError();

/*****/
const mode = ref("countries");

const mapScale = computed(() => {
  if (ifStore.mapScaleSwitchBool) {
    return "quantile";
  } else {
    return "linear";
  }
});
const resultsForMapSelectedCountry = ref([]);

const { data: resultsForMapBase, refresh: refreshBaseMap } = await useAsyncData(
  "allcountries" + ifStore.sliderYears[0] + ifStore.sliderYears[1],
  () => {
    const allCountries = httpConfig(
      JSON.stringify(
        queries.getAllCountriesByCountryTotal(ifStore.sliderYears)
      )
    );
    return $fetch(config.public.apiURL, allCountries).catch((error) =>
      reloadOnError.refreshReload()
    );
  },
  {
    transform: (data) => {
      return data.documents.map((d) => {
        const item = allRecipients.find((r) => r.iso === d._id);
        return {
          ...d,
          label: item?.name,
          recipient_code: item?.recipient_code,
        };
      });
    },
  }
);
const selectedDonor = ref(null);

const resultsForMap = computed(() => {
  if (selectedDonor.value == null) {
    return resultsForMapBase.value;
  } else {
    return resultsForMapSelectedCountry.value;
  }
});

function pullDataAllCountriesOneDonor() {
  const configAllRecipients = httpConfig(
    JSON.stringify(
      queries.getAllCountriesByCountryOneDonor(
        selectedDonor.value._id,
        ifStore.sliderYears
      )
    )
  );
  $fetch(config.public.apiURL, configAllRecipients).then((res) => {
    resultsForMapSelectedCountry.value = res.documents.map((d) => {
      return {
        ...d,
        label: allRecipients.find((r) => r.iso === d._id)?.name,
      };
    });
  })
  .catch((error) =>
      reloadOnError.refreshReload()
    );
}
watch(selectedDonor, (newVal, oldVal) => {
  if (newVal !== oldVal && newVal !== null) {
    pullDataAllCountriesOneDonor();
  }
});

watch(
  () => ifStore.sliderYears,
  (newValue, oldValue) => {
    refreshBaseMap();
    if (selectedDonor.value != null) {
      pullDataAllCountriesOneDonor();
    }
  }
);

// data for regions map

const { data: resultsForBubbleChart, refresh: refreshBubbleChart } =
  await useAsyncData(
    "allRegions" + ifStore.sliderYears[0] + ifStore.sliderYears[1],
    () => {
      const allCountries = httpConfig(
        JSON.stringify(queries.getAllRegionsByRegionTotal(ifStore.sliderYears))
      );
      return $fetch(config.public.apiURL, allCountries).catch((error) =>
        reloadOnError.refreshReload()
      );
    },
    {
      transform: (data) => {
        
        return data.documents
          .filter((d) => !isNaN(d._id))
          .map((d) => {
            const item= regionsCentroids.find((r) => r.recipient_code == d._id);
            if(item == undefined || item == null){              
              console.log("region not found in regionsCentroids.json: "+d._id);
              return; // Omit this item; skip to next
            }
            else{ 
              return {
                recipient_code: parseInt(d._id),
                value: d.Total,
                name: item
                  ?.name, // comparing string 'code' with number code
                centroid: item
                  ?.centroid,
              };
            }
          })
          .filter((d) => d !== undefined)
          .sort((a, b) => b.value - a.value);
      },
    },
  );

watch(
  () => ifStore.sliderYears,
  (newValue, oldValue) => {
    refreshBubbleChart();
  }
);

// tooltip
const tooltip = useTooltip();
const tooltipId = ref("geo");

const hoveredData = ref(null);
const hoveredHeader = ref(null);
const showTeleport = ref(false);

const onCountryOver = (country) => {
  hoveredData.value = {
    label: country.name,
    figure: $formater.salaryFormater(country.value),
  };
  hoveredHeader.value = "RECIPIENT";
  showTeleport.value = true;
  tooltipId.value = "worldmap";
  tooltip.show(country.x, country.y, "worldmap");
};

const onCountryOut = () => {
  tooltip.hide();
  nextTick().then(() => {
    showTeleport.value = false;
  });
};

const onCountryClick = (geoId) => {
  // get the recipient_code from the geoID (iso code)
  const recipient_code = allRecipients.find(
    (r) => r.iso === geoId
  )?.recipient_code;

  if (recipient_code === undefined) {
    const donor_iso_code = geoId;
    // TBD shows modal
    const donor = store.allDonorNames.find(
      (item) => item.iso === donor_iso_code
    );
    showGeoModal.value = true;
    selectedEntity.value.name = donor._id;
    selectedEntity.value.id = donor_iso_code;
    selectedEntity.value.nodeType = nodeTypes.donor;
    selectedEntity.value.filterByDonorCode = "";
    selectedEntity.value.filterByDonorName = "";
    selectedEntity.value.topCountries =
      resultsForMapSelectedCountry.value.slice(0, 10);
  } else {
    const recipient = allRecipients.find((r) => r.iso === geoId);
    // TBD shows modal
    showGeoModal.value = true;
    selectedEntity.value.nodeType = nodeTypes.recipient;
    selectedEntity.value.name = recipient.name;
    selectedEntity.value.id = recipient.recipient_code + "";
    if (selectedDonor.value != null) {
      selectedEntity.value.filterByDonorCode = selectedDonor.value.iso;
      selectedEntity.value.filterByDonorName = selectedDonor.value._id;
    } else {
      selectedEntity.value.filterByDonorCode = "";
      selectedEntity.value.filterByDonorName = "";
    }
  }
};

const onRegionOver = (region) => {
  hoveredData.value = {
    label: region.name,
    figure: $formater.salaryFormater(region.value),
  };
  hoveredHeader.value = "RECIPIENT REGION";
  showTeleport.value = true;
  tooltipId.value = "geomap";
  tooltip.show(region.x, region.y, "geomap");
};
const onRegionOut = (region) => {
  tooltip.hide();
  nextTick().then(() => {
    showTeleport.value = false;
  });
};

const onRegionClick = (region) => {
  // region : {value: 959.899671, name: 'Europe', recipient_code: 89}
  // TBD shows modal
  // TBD shows modal
  showGeoModal.value = true;
  selectedEntity.value.nodeType = nodeTypes.recipient;
  selectedEntity.value.name = region.name;
  selectedEntity.value.id = region.recipient_code + "";
  selectedEntity.value.filterByDonorCode = "";
  selectedEntity.value.filterByDonorName = "";
};

const mapWidth = computed(() => {
  if (process.server) return 800;
  else {
    if (window.innerWidth >= 1024 && selectedDonor.value !== null) {
      return availableWidth.value - 300;
    } else {
      return Math.max(768, availableWidth.value);
    }
  }
});

// const resizeWindow = () => {
//   if (window.innerWidth >= 1024 && selectedDonor.value !== null) {
//     mapWidth.value = availableWidth.value - 300;
//   } else {
//     mapWidth.value = availableWidth.value;
//   }
// };
onMounted(() => {
  //window.addEventListener("resize", resizeWindow);
  // resizeWindow();
});
onUnmounted(() => {
  // window.removeEventListener("resize", resizeWindow);
});

const closeDonor = () => {
  selectedDonor.value = null;
  resetFlag.value = !resetFlag.value;
};
</script>

<style lang="css" scoped></style>
